namespace Nobox.CRM {
    export interface ProductExcelImportResponse extends Serenity.ServiceResponse {
        Inserted?: number;
        Updated?: number;
        ErrorList?: string[];
        data?: System.Data.DataTable;
    }
}
